import {QuestionResult} from "../FxeQuizQuestions";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {FxeQuizService} from "./FxeQuizService";
import {QuizScore} from "./models/QuizScore";
import {IHttpService} from "angular";
import {AccountStore} from "../../../account/store/AccountStore";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export class FxeQuizDialogController {

    public mode = "quiz";
    public results: Array<QuestionResult> | null;
    private passed = false;

    /** @ngInject */
    public constructor(private readonly $uibModalInstance: IModalInstanceService,
                       private readonly fxeQuizService: FxeQuizService,
                       private readonly $http: IHttpService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly accountStore: AccountStore) {

    }

    public quizComplete(results: Array<QuestionResult>) {
        this.results = results;
        this.mode = "results";
    }

    public async recordScore(score: QuizScore) {
        const userId = this.currentUserService.userId;
        const url = `/tradefloor/api/user/${userId}/options-quiz`;
        await this.$http.post<void>(url, score);
        this.passed = score.passed;
        if (this.passed) {
            this.currentUserService.refreshConfig();
            this.accountStore.refresh();
        }
    }

    public reset() {
        this.mode = "quiz";
        this.results = null;
    }

    public async complete() {
        if (this.passed) {
            this.$uibModalInstance.close();
        } else {
            this.$uibModalInstance.dismiss();
        }
    }
}
